export default __webpack_public_path__ + "static/media/empty_prizes.22ef1db8.png";